import SocialSharing from './components/SocialSharing.vue';
import './styles/entry.scss';

export default {
  install(app) {
    app.component(SocialSharing.name, SocialSharing);
  },
};
